import { ReactNode } from 'react'

/** Left half of the landing and loading screens: dark panel with the restaurant photo behind */
export const UploadPanel = ({ children }: { children: ReactNode }) => (
  <div className="w-1/2 relative bg-brand-secondary flex-shrink-0">
    <div
      className="absolute inset-0 bg-cover bg-center opacity-40"
      style={{ backgroundImage: 'url(/restaurant-tables.jpg)' }}
    />
    <div className="relative z-10 h-full flex flex-col items-center justify-center p-8">
      <div className="w-full max-w-md">{children}</div>
    </div>
  </div>
)
